import React, { useEffect, useState } from "react";
import { ProgressBar } from "primereact/progressbar";
import { Chart } from "primereact/chart";
import HorizontalBarCharts from "./Dashboard Widgets/HorizontalBarCharts";
import ClinicPatientSlot from "./Dashboard Widgets/ClinicPatientSlot";
import DRDashboardWidgets from "./Dashboard Widgets/DRDashboardWidgets";
import TableData from "./Dashboard Widgets/TableData";
import { useLocation, useNavigate } from "react-router-dom";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import DocStats from "./DoctorComponent.jsx/DoctorDashboard/DocStats";
import DocInfo from "./DoctorComponent.jsx/DoctorDashboard/DocInfo";
import {useGetAllDocDashboardQuery} from '../State/Api/AdddocApiSlice';
import DocSchedule from "./DoctorComponent.jsx/DoctorDashboard/DocSchedule";
import DocClinicInfo from "./DoctorComponent.jsx/DoctorDashboard/DocClinicInfo";
import DocReportTable from "./DoctorComponent.jsx/DoctorDashboard/DocReportTable";
import { DatePicker } from "rsuite";
import DrAppointmentTableWidget from "./DoctorComponent.jsx/Tables/DrAppointmentTableWidget";
import PlanExpiryModal from "./ClinicModal/PlanExpiryModal";

// Dummy Data
const statCards = [
  {
    title: "Today's Appointments",
    value: "100",
    change: "+20% from Yesterday",
    icon: "fa-solid fa-calendar-check",
  },
  {
    title: "Video Consult Appointments",
    value: "50",
    change: "+15% from last week",
    icon: "fa-solid fa-video",
  },
  {
    title: "Follow-Up Appointments",
    value: "50",
    change: "+15% from last week",
    icon: "fa-solid fa-user-check",
  },
  {
    title: "Cancelled Appointments",
    value: "10",
    change: "-20% from Yesterday",
    icon: "fa-solid fa-xmark-circle",
  },
  {
    title: "Walk-in Appointments",
    value: "80",
    change: "-15% from Yesterday",
    icon: "fa-solid fa-walking",
  },
  {
    title: "Rescheduled Appointments",
    value: "50",
    change: "+30% from last week",
    icon: "fa-solid fa-arrows-rotate",
  },
];

const clinics = [
  {
    name: "MedCare Clinic",
    img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?fit=facearea&w=64&h=48", // Replace with your clinic image
    address: "4517 Washington Ave. Manchester, Kentucky 39495",
    price: "₹ 700",
    open: true,
    schedule: [
      { day: "MON", time: "10:00 AM – 7:00 PM" },
      { day: "TUE", time: "10:00 AM – 7:00 PM" },
      { day: "WED", time: "8:00 AM – 12:00 PM" },
      { day: "THU", time: "10:00 AM – 7:00 PM" },
      { day: "FRI", time: "10:00 AM – 7:00 PM" },
      { day: "SAT & SUN", time: "Closed", closed: true },
    ],
  },
];

const today = new Date();
const navProfileImg = "https://randomuser.me/api/portraits/men/85.jpg"; // Just sample



const statusCounts = {
  Today: 5,
  Waiting: 1,
  Engaged: 2,
  Done: 1,
};

function DoctorDashBoard() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("All");
  const [activeTab, setActiveTab] = useState("Appointments");
  const [openIndex, setOpenIndex] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const location = useLocation();
  const [showPlanExpiryModal, setShowPlanExpiryModal] = useState(false);
  const [expiryMessage, setExpiryMessage] = useState('');

useEffect(() => {
  console.log("DoctorDashBoard location state:", location.state);
  if (location.state?.showPlanExpiryModal) {
    setExpiryMessage(location.state.expiryMessage || "Your plan is expiring soon.");
    setShowPlanExpiryModal(true);
  }
}, [location.state]);

    const doctorUserUniqueID = localStorage.getItem("userUniqueID");
  const clinicId = localStorage.getItem("userClinicID");

    const {
    data,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetAllDocDashboardQuery({ doctorUserUniqueID, clinicId,startDate: startDate ? startDate.toISOString().split("T")[0] : "",endDate: endDate ? endDate.toISOString().split("T")[0] : "" });

  // Convert API data to chart format
const revenueData = {
  labels: data?.revenuePerDay?.map(d => d.dayName) ?? [],
  datasets: [
    {
      label: "Revenue",
      data: data?.revenuePerDay?.map(d => d.totalRevenue) ?? [],
      backgroundColor: "#F73C56",
      borderRadius: 7,
      barPercentage: 0.6,
      categoryPercentage: 0.7,
    }
  ]
};

const appointmentsData = {
  labels: data?.appointmentsPerDay?.map(d => d.dayName) ?? [],
  datasets: [
    {
      label: "Appointments",
      data: data?.appointmentsPerDay?.map(d => d.totalAppointments) ?? [],
      backgroundColor: "#F7BB3C",
      borderRadius: 7,
      barPercentage: 0.6,
      categoryPercentage: 0.7,
    }
  ]
};


const revenueOptions = {
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "#fff",
      titleColor: "#000",
      bodyColor: "#000",
      padding: 10,
      borderRadius: 8,
    },
  },
  scales: {
    x: {
      grid: { display: false, drawBorder: false },
      ticks: { color: "#B9B6BB", font: { size: 14, weight: 600 } },
    },
    y: {
      grid: { color: "#F7E7EA", drawBorder: false },
      ticks: {
        color: "#B9B6BB",
        callback: (v) => (v >= 1000 ? v / 1000 + "k" : v),
        font: { size: 13 },
      },
      beginAtZero: true,
      max: 35000,
      stepSize: 5000,
    },
  },
  maintainAspectRatio: false,
};

const appointmentsOptions = {
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "#fff",
      titleColor: "#000",
      bodyColor: "#000",
      padding: 10,
      borderRadius: 8,
    },
  },
  scales: {
    x: {
      grid: { display: false, drawBorder: false },
      ticks: { color: "#B9B6BB", font: { size: 14, weight: 600 } },
    },
    y: {
      grid: { color: "#F7E7EA", drawBorder: false },
      ticks: {
        color: "#B9B6BB",
        font: { size: 13 },
      },
      beginAtZero: true,
      max: 30,
      stepSize: 5,
    },
  },
  maintainAspectRatio: false,
};


  // Helper
  function formatDate(date) {
    return date.toLocaleDateString("en-GB", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  return (
    <>
      <style>
        {`
     .dashboard-container {
  width: 100%;
  max-width: 100%;
}
        .stats-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 10px; margin-bottom: 20px; }
        .stat-card { position: relative; border-radius: 16px; padding: 15px; background: #fff; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); display: flex; justify-content: space-between; overflow: hidden; }
        .circle-before, .circle-after { content: ''; position: absolute; border-radius: 50%; z-index: 0; }
        .circle-before { width: 120px; height: 120px; top: -40px; right: 70%; }
        .circle-after { width: 200px; height: 200px; bottom: -80px; left: -80px; }
        .stat-content { position: relative; z-index: 1; }
        .stat-card h3 { font-size: 1.8rem; margin: 0; color: #111827; }
         .stat-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
        }
        .stat-title { margin: 4px 0; font-size: 1rem; color: #4b5563; }
        .stat-change { font-size: 0.85rem; }
        .action-buttons { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; align-items: center; }
        .action-btn { background-color: #462860; color: #fff; border: none; padding: 12px 0; border-radius: 8px; font-size: 10px; cursor: pointer; width: 100%; }
        .bottom-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px; }
        .bottom-grid > .card {
          height: 450px; /* fixed height */
         overflow-y: auto; /* vertical scroll for entire card */
            scrollbar-width: none;
         }
           .bottom-grid > .card::-webkit-scrollbar {
           display:none;
           }
          .bottom-grid > .card::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.2);
           border-radius: 3px;
        }
        .card { background: #fff; border-radius: 12px; padding: 16px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05); }
        .card h4 { color: #f97316; margin-bottom: 10px; }
        .list-item { display: flex; justify-content: space-between; align-items: center; padding: 10px; margin-top: 10px; background: #f9fafc; border-radius: 8px; }
        .badge { background: #ff6600; color: #fff; border-radius: 8px; padding: 5px 10px; font-weight: bold; }
        .hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
             .rs-picker-popup {
    z-index: 9999 !important;
  }
  .rs-input-group {
    border-radius: 8px !important;
    border: #e5e5ea solid 1px !important;
    height: 35px;
    overflow: hidden;
    background: white;
    
  }
  .rs-input-group .rs-input {
    border-radius: 8px !important;
    border: none !important;
    background: none !important;
    box-shadow: none !important;
  }
  .rs-input-group .rs-input:focus {
    outline: none;
    box-shadow: none;
  }
  .rs-picker-toggle {
    border-radius: 8px !important;
  }
  .rs-input-group-inside .rs-input {
    border: none !important;
    font-size:14px;
    border-radius: 8px !important;
    box-shadow: none !important;
    background: none !important;
  }
    `}
      </style>
       <PlanExpiryModal
        show={showPlanExpiryModal}
        message={expiryMessage}
        onClose={() => setShowPlanExpiryModal(false)}
      />
      <div style={{ minHeight: "100vh", padding: 10, marginBottom: 40 }}>
        <div>
          <h2 className="text-xl font-semibold" style={{ fontSize: '24px' }}>Doctor Dashboard</h2>
          {/* <p className="text-sm text-muted-foreground">Insights and trends from your doctor data</p> */}
        </div>


        {/* Header */}
        <div className="row mb-3 gx-3 mt-3">
           
         <DocInfo
  doctor={data?.doctor}
  upcomingAppointment={data?.upcomingAppointment}
  isLoading={isLoading}
  isSuccess={isSuccess}
/>
        </div>

        {/* Top Stat Cards */}
      <DocStats
  stats={data?.stats}
  isLoading={isLoading}
  isSuccess={isSuccess}
/>

        {/* Middle Section */}
        <div className="row mb-3 gx-4">
          {/* Calendar */}
          <div className="col-12 col-lg-7 col-xl-8">
            {/* <FullCalendar
              buttonText={{
                today: "Today",
                month: "Month",
                week: "Week",
                day: "Day",
                list: "List",
              }}
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                listPlugin,
                interactionPlugin,
              ]}
            /> */}
            <DrAppointmentTableWidget data={data}  />
            {/* Revenue / Appointments Chart */}
            <div className="bg-white rounded-3 shadow-sm p-3 mt-2">
              <div className="d-flex mb-2 justify-content-between align-items-center">
      <div className="fw-semibold" style={{ fontSize: "1.07em" }}>
        Weekly Overview
      </div>

      <div
        className="text-muted small d-flex align-items-center"
        style={{ gap: 6 }}
      >
        <DatePicker
          oneTap
          placeholder="Start Date"
          value={startDate}
          onChange={setStartDate}
          format="dd-MMM-yyyy"
          style={{ width: '10rem'}}
        />

        <span>-</span>

        <DatePicker
          oneTap
          placeholder="End Date"
          value={endDate}
          onChange={setEndDate}
          format="dd-MMM-yyyy"
          style={{ width: '10rem'}}
        />
      </div>
    </div>
              {/* Tabs */}
              <div className="d-flex gap-3 mb-2">
                
                <button
                  className="btn btn-link px-0"
                  onClick={() => setActiveTab("Appointments")}
                  style={{
                    fontWeight: activeTab === "Appointments" ? 700 : 500,
                    color: activeTab === "Appointments" ? "#F73C56" : "#BAB3B8",
                    borderBottom:
                      activeTab === "Appointments"
                        ? "2.5px solid #F73C56"
                        : "none",
                    background: "transparent",
                    fontSize: "1.03em",
                    padding: "0 14px 4px 0",
                  }}
                >
                  Appointments
                </button>
              </div>
              <div style={{ width: "100%", height: 270 }}>
                <Chart
  type="bar"
  data={activeTab === "Revenue" ? revenueData : appointmentsData}
  options={activeTab === "Revenue" ? revenueOptions : appointmentsOptions}
  height="250px"
/>
              </div>
            </div>


          </div>
          {/* Right Column */}
          <div className="col-12 col-lg-5 col-xl-4">
         
            {/* Today's Schedule */}
          <DocSchedule
  schedules={data?.todaySchedules}
  isLoading={isLoading}
  isSuccess={isSuccess}
/>
            {/* Clinics & Avail */}
       <DocClinicInfo
  clinic={data?.clinic}
  weeklySchedules={data?.weeklySchedules}
  isLoading={isLoading}
  isSuccess={isSuccess}
/>

          </div>
        </div>
      </div>
    </>
  );
}

export default DoctorDashBoard;
